const OrderedTimeUnits = ['MINUTES', 'HOURS', 'DAYS', 'WEEKS'];
const defaults = {
  timeUnit: 'HOURS',
  numberOfTimeUnits: 1
};
export function createReminder(props) {
  var _props$timeUnit, _props$numberOfTimeUn;
  return Object.assign({
    timeUnit: (_props$timeUnit = props === null || props === void 0 ? void 0 : props.timeUnit) !== null && _props$timeUnit !== void 0 ? _props$timeUnit : defaults.timeUnit,
    numberOfTimeUnits: (_props$numberOfTimeUn = props === null || props === void 0 ? void 0 : props.numberOfTimeUnits) !== null && _props$numberOfTimeUn !== void 0 ? _props$numberOfTimeUn : defaults.numberOfTimeUnits
  }, (props === null || props === void 0 ? void 0 : props.ticks) !== undefined && {
    ticks: props.ticks
  });
}
export function compareReminders(a, b) {
  if (OrderedTimeUnits.indexOf(a.timeUnit) !== OrderedTimeUnits.indexOf(b.timeUnit)) {
    return OrderedTimeUnits.indexOf(a.timeUnit) - OrderedTimeUnits.indexOf(b.timeUnit);
  }
  return a.numberOfTimeUnits - b.numberOfTimeUnits;
}

// TODO: Remove in Phase 6 after downstream repos migrate to createReminder()
class ReminderCompat {
  constructor(props) {
    const result = createReminder(props);
    this.timeUnit = result.timeUnit;
    this.numberOfTimeUnits = result.numberOfTimeUnits;
    this.ticks = result.ticks;
    return result;
  }
}
export default ReminderCompat;